module.exports = __webpack_public_path__ + "components/AuthorizationModal/deny-2-d8f5fbd9adda8b357596c7b0bb0876de.svg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/components/AuthorizationModal/deny-2.svg
// module id = 205
// module chunks = 0 1